import Offer from './offer';
import Delivery from './delivery';
import User from './user';
import Resume from './resume'
import Person from './person'
export interface IMobxState {
  offer: Offer,
  delivery: Delivery,
  user: User,
  resume: Resume,
  person: Person,
}

const resident = {
  offer: new Offer(),
  delivery: new Delivery(),
  user: new User(),
  resume: new Resume(),
  person: new Person(),
}
export default resident;
